import React from 'react'
import Yurtici from './Yurtici'
import { useLocation } from 'react-router-dom'
import MusteriYorumlari from './MusteriYorumlari'

const Referanslar = () => {
  const location = useLocation()

  const splitedLocation = location.pathname.split('/')
  const path1 = splitedLocation[2]

  return (
    <>
      {
        path1 === 'musteri-yorumlari' ? (
          <MusteriYorumlari/>
        ) : (
          <Yurtici/>
        )
      }
    </>
  )
}

export default Referanslar